<template>
    <div id="editor_text">
        <editorLongTextChapter></editorLongTextChapter>
        <editorLongTextContext></editorLongTextContext>
    </div>
</template>

<script>
import editorLongTextChapter from '@/components/script/editor_textChapter.vue' //章纲概述
import editorLongTextContext from '@/components/script/editor_textContext.vue' //章纲正文
export default {
    components:{
        editorLongTextChapter,editorLongTextContext
    }
}
</script>

<style>
#editor_text{
    width: 100%;
    height: 100%;
    display: flex;
}
</style>